import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import * as moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { DialDialogComponent } from './dial-dialog/dial-dialog.component';
import { Subject } from 'rxjs';
import { getZoomrateFromElement } from '@app/shared/common/utils';

const hour24 = /^([01][0-9]|2[0-3]):[0-5][0-9]$/;

@Component({
  selector: 'app-timepicker',
  templateUrl: './timepicker.component.html',
  styleUrls: ['./timepicker.component.scss'],
})
export class TimepickerComponent implements OnChanges {
  selectTime: string = '12:00';
  options: string[];
  format: string = 'HH:mm';
  @Input() disabled: boolean = false;
  @Input() placeholder: string = '選択して下さい';
  @Output() formChange = new EventEmitter<FormControl>();
  timeChange$: Subject<string> = new Subject();
  private _form!: FormControl;
  @Input()
  get form(): FormControl {
    return this._form;
  }
  
  dateValue: Date = new Date();
  set form(form: FormControl) {
    this._form = form;
    this._form.addValidators(Validators.pattern(hour24));
    // if (form.value) {
    //   this.setSelectTime(form.value);
    // }
  }

  get inputStyle() {
    if (this.disabled) {
      return { color: 'transparent' }
    }
    return {};
  }

  constructor(private dialog: MatDialog, private ele: ElementRef) {
    this.options = [...Array(144)].map((_, i) => {
      const d = new Date('2020-01-01T00:00:00Z');
      d.setMinutes(i * 10);
      return d.toISOString().substring(11, 16);
    });

    this.timeChange$.subscribe((value: string) => {
      this.onOptionClick(value);
    })
  }

  ngOnDestroy(): void {
    this.timeChange$.unsubscribe();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['form']) {
      this.dateValue = moment(this.form.value, this.format).toDate();
    }
  }

  // setSelectTime(value: string): void {
    // if (hour24.test(value)) {
    //   this.selectTime = `0${value}`.slice(-5, -1) + '0';
    // }
  // }

  onInputChange(): void {
    this.formChange.emit(this.form);
   // this.setSelectTime(this.form.value);
  }

  dateUpdate(e: any) {
    const value = e.target.value;
    this.form.setValue(value);
    this.dateValue = moment(this.form.value, this.format).toDate();
    this.onInputChange();
  }

  onOptionClick(value: string): void {
    this.form.setValue(value);
    this.formChange.emit(this.form);
  }

  triggerDial() {
    let { height, top, left } = this.ele.nativeElement.getBoundingClientRect();
    let zoomrate = getZoomrateFromElement();
    let viewPosition = top + height;
    let possibleDialogHeight = 168;
    if (viewPosition + possibleDialogHeight >= (window.innerHeight || document.documentElement.clientHeight)) {
      viewPosition -= possibleDialogHeight;
    }

    this.dialog.open(DialDialogComponent,
      {
        data: { timeChange$: this.timeChange$, time: this.form.value },
        position: { left: `calc(${left}px/${zoomrate * zoomrate})`, top:`calc(${viewPosition}px/${zoomrate * zoomrate})`}
      }).afterClosed().subscribe((value) => {
        if (value) {
          this.onOptionClick(value)
        }
      });
  }
}
